// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"eq-z","breadcrumbForward":"fq-z","breadcrumbBack":"gq-z","selected":"hq-z"};